"use client";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AuthModal } from "@components/auth/AuthModal";
import HandlePasswordChange from "@components/auth/HandlePasswordChange";
import { RootState } from "@store/store";
import { closePasswordRecoveryModal, openLoginModal } from "@store/features/userActionsSlice";

export function PasswordRecoveryModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.userActions.isPasswordRecoveryModalOpen);

  const handleClose = () => {
    dispatch(closePasswordRecoveryModal());
  };

  const handleOpenLogin = () => {
    dispatch(closePasswordRecoveryModal());
    dispatch(openLoginModal());
  };

  return (
    <AuthModal
      isOpen={isOpen}
      onClose={handleClose}
      title= {t("auth.reset-password-title")}
    >
      <div className="p-4">
        <HandlePasswordChange />
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            <button
              onClick={handleOpenLogin}
              className="text-blue-600 hover:underline font-medium text-xs"
            >
              {t("auth.back-to-login")}
            </button>
          </p>
        </div>
      </div>
    </AuthModal>
  );
}
